import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators,FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';

import { DashboardService } from 'src/app/modules/service/dashboard.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-update-broker-admin',
  templateUrl: './update-broker-admin.component.html',
  styleUrls: ['./update-broker-admin.component.scss']
})
export class UpdateBrokerAdminComponent implements OnInit {

  currentUser;


  requestPayload = {
   
    broker_admin_main_code: '',
    broker_admin_email: '',
    broker_admin_phone: '',
    broker_admin_first_name: '',
    broker_admin_last_name: '',
    broker_admin_office: 'Accra',
    broker_admin_modified_by: ''
  }

  updateBrokerForm: FormGroup;

  constructor(public formBuilder: FormBuilder,public service: DashboardService, private router:Router,public dialogRef: MatDialogRef<UpdateBrokerAdminComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { 



      this.updateBrokerForm = this.formBuilder.group({
     //   broker_user_code:new FormControl(data.broker_user_code),
        broker_user_main_broker_code:new FormControl(data.broker_user_main_broker_code),
        broker_admin_email:new FormControl(data.broker_admin_email,[Validators.required]),
        broker_admin_phone:new FormControl(data.broker_admin_phone,Validators.required),
        broker_admin_first_name:new FormControl(data.broker_admin_first_name,[Validators.required]),
        broker_admin_last_name:new FormControl(data.broker_admin_last_name,[Validators.required]),
        broker_admin_office:new FormControl(data.broker_admin_office),
        broker_admin_main_code:new FormControl(data.broker_admin_main_code,[Validators.required]),
      })


    }

  ngOnInit() {

    this.currentUser=JSON.parse(localStorage.getItem('userdata'));
  }


  putBroker() {
    if (this.updateBrokerForm.valid) {
      this.requestPayload = this.updateBrokerForm.value;
      this.requestPayload.broker_admin_modified_by = this.currentUser.email;
     

      console.log("requestPayload:  " + JSON.stringify(this.requestPayload));

      Swal.showLoading();
      this.service.updateBrokerAdmin(this.requestPayload)
        .subscribe(response => {
          console.log(response);

          Swal.close();
          if (response['responseCode'] === '000') {

            (Swal as any).fire({
              icon: 'success',
              title: 'Successful',
              text: 'Broker user account updated successfully.',
            });

              this.dialogRef.close({event:'updated'});
            // this.router.navigate(['/brokers'])

          } else {
            (Swal as any).fire({
              icon: 'warning',
              title: 'Oops...',
              text: response['responseMessage'],
              footer: ''
            });
          }

        }, error => {
          (Swal as any).fire({
            icon: 'error',
            title: 'Oops...',
            text: error,
            footer: ''
          });
          Swal.close();
        })


    } else {
      (Swal as any).fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Please fill all form fields',
        footer: ''
      });

    }
  }


}
